var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { t } from "../I18N";
import Modal from "../Layout/Modal";
// eslint-disable-next-line import/exports-last
export default class ModalTips extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  render() {
    return /*#__PURE__*/(
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("div", { className: "modal-tip-label", onClick: () => this.setState({ isOpen: true }) }, void 0,
      this.props.label), /*#__PURE__*/

      _jsx(Modal, { isOpen: this.state.isOpen, type: this.props.type, className: "modal-tip-dim" }, void 0, /*#__PURE__*/
      _jsx(Modal.Body, {}, void 0, /*#__PURE__*/
      _jsx("h4", {}, void 0, this.props.title),
      this.props.children), /*#__PURE__*/

      _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "btn confirm-button btn-info",
        onClick: () => this.setState({ isOpen: false }) }, void 0,

      t('System', 'Accept'))))));





  }
}

ModalTips.defaultProps = {
  type: 'info'
};